define('OutSystems/ClientRuntime/modules/Common/UrlUtils',["require", "exports", "../../RegExpHelper"], function (require, exports, RegExpHelper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.buildURLFromVersionedResource = exports.replaceBasePath = void 0;
    var replaceBasePath = function (url, originalBasePath, newBasePath) {
        if (originalBasePath.toLowerCase() === newBasePath.toLowerCase()) {
            return url;
        }
        var originalBasePathRegExp = new RegExp("^" + RegExpHelper_1.escape(originalBasePath), "i");
        return url.replace(originalBasePathRegExp, newBasePath);
    };
    exports.replaceBasePath = replaceBasePath;
    var buildURLFromVersionedResource = function (baseUrl, token) { return "" + baseUrl + token; };
    exports.buildURLFromVersionedResource = buildURLFromVersionedResource;
});
//# sourceMappingURL=UrlUtils.js.map;
